import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BorderouComponent } from './borderou.component';
import { MaterialModule } from 'src/app/material.module';
import { AddBorderouComponent } from './add-borderou/add-borderou.component';

@NgModule({
    declarations: [BorderouComponent, AddBorderouComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [BorderouComponent]
})
export class BorderouModule { }
